import React, {memo } from 'react';
import { Link } from 'react-router-dom';

import RouteConstants from '../routes';

import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';

import useStyles from '../styles/Styles';

import _ from 'lodash';

const MemberLinks = memo(({current, absencesOn, openPassword, openNameBadge}) => {
	const classes = useStyles();
	
	const links = {
		member: {
			primary: 'Member Details',
			secondary: 'View and update member details',
			show: current !== 'member'
		},
		member_enrolments: {
			primary: "Enrolments",
			secondary: "View enrolments",
			show: current !== 'member_enrolments'
		},
		member_invoices: {
			primary: "Invoices",
			secondary: "View and pay invoices",
			show: current !== 'member_invoices'
		},
		member_absences: {
			primary: "Absences",
			secondary: "View and register absences",
			show: absencesOn && current !== 'member_absences'
		}
	}
	
	return (
		<>
		<div className={classes.sectionTitle}>
			<Typography variant="h5" component="h2">Member links</Typography>
		</div>
		<Grid container>
		<Grid item sm={12} md={6}>
		<List className={classes.contentList} >
		{_.map(links, (l, k) => {
			return l.show ? 
			<ListItem key={k}>
				<ListItemAvatar>
				  <Avatar>
				  {RouteConstants[k].icon}
				  </Avatar>
				</ListItemAvatar>
				<ListItemText color="primary"
					primary={l.primary}
					secondary={<Link to={RouteConstants[k].path}>{l.secondary}</Link>}
					/>
			</ListItem>
			: null
		})}
		</List>
		</Grid>
		<Grid item sm={12} md={6}>
		<List className={classes.contentList} >
		{openPassword === false ? null :
			<ListItem>
				<ListItemText color="primary"
					primary="Password"
					secondary={<Button variant="outlined" size="small" color="primary" className={classes.button}
					onClick={() => openPassword(true)}
					>Change Password</Button>}
				/>
			</ListItem>
		}
		{openNameBadge === false ? null :
			<ListItem>
				<ListItemText color="primary"
					primary="Name badge"
					secondary={<Button variant="outlined" size="small" color="primary" className={classes.button}
					onClick={() => openNameBadge(true)}
					>Generate Name Badge</Button>}
				/>
			</ListItem>	
		}
		</List>
		</Grid>
		</Grid>
		</>
)})

export default MemberLinks